import { RECEIVED_BRAND_DATA, GET_DATA, UPDATE_DATA, NEW_SIMULATION, EXIT_SIMULATION, LOAD_SIMULATION, GET_SAVED_SIMULATIONS, RECEIVE_RELEVANCE_DATA, SET_RELEVANCE_GROUP, DID_REQUEST_INITIAL_DATA, SET_START_DATE, SET_END_DATE, TOGGLE_TIMELINE_ACTIVE, INIT_TELESCOPE, RECEIVED_TELESCOPE_DATA, SET_AVAILABLE_DATES, TOGGLE_RELEVANCE_CHART, RECEIVED_BRAND_AWARENESS_DATA, RECEIVED_AD_AWARENESS_DATA, RECEIVED_BRAND_CONSIDERATION_DATA, UPDATE_WASHED_SENTIMENT_DATA, GET_CLIENTS } from '../actionTypes';

/**
  * Get the min and max values from all Ps (variables), relevance score and relevance target to set the scale of all P-sliders
  * @param {Object} variables Data of the 7 Ps
  * @param {Number} score Relevance score
  * @param {Number} target Relevance target
*/
function variableMinMax(variables, score, target) {
  let scores = [];
  if (score) {
    scores.push(score);
  }
  if (target && target.target) {
    scores.push(target.target);
  } else if (target) {
    scores.push(target);
  }

  variables.forEach(function(v, i) {
    let useScore='nscore';

    if (v[useScore]) {
      scores.push(v[useScore])
    }
    if (v[useScore] && v.target) {
      if (v.target.target) {
        scores.push(v.target.target)
      } else {
        scores.push(v.target)
      }
    }
  });

  const min = parseInt(Math.min(...scores), 10);
  const max = parseInt(Math.max(...scores), 10);
  const padding = 10;
  const out = {min: min - padding , max: max + padding};

  return out;
};

export default function(state = {}, action) {
    switch (action.type) {
      case INIT_TELESCOPE:
        return {
          ...state,
          telescope: action.payload
        }
      case RECEIVED_BRAND_DATA:
       let brandData = state.brandData || {};
       brandData[action.payload.brand] = action.payload.data;
       return {
         ...state,
         brandData: brandData
       }

      case RECEIVED_TELESCOPE_DATA:
        const varData = action.payload.variables;
        const varMinMax = variableMinMax(varData, action.payload.score, action.payload.target);
        let highestPotentialVar;
        let highestPotentialScore = -10000;
        let sentimentData = {}

        if (!varData || !varData.length) {
          return null;
        }

        // Find P with highest potential
        varData && varData.forEach(v => {
          if (v.potential > highestPotentialScore) {
            highestPotentialVar = v;
            highestPotentialScore = v.potential;
          }
        });

        sentimentData.highestPotentialVar = highestPotentialVar;

        return {
          ...state,
          variableData: action.payload,
          variableMin: varMinMax.min,
          variableMax: varMinMax.max,
          sentimentData: sentimentData,
          newSubscriptions: action.payload.newSubscriptions
        }
      case SET_START_DATE:
        return {
          ...state,
          startDate: action.payload
        }
      case SET_END_DATE:

        return {
          ...state,
          endDate: action.payload,
        }
      case SET_AVAILABLE_DATES:
        return {
          ...state,
          availableDates: action.payload
        }
      case TOGGLE_TIMELINE_ACTIVE:
        return {
          ...state,
          timelineActive: action.payload
        }
      case GET_DATA:
        return {
            ...state,
            relevanceGroup: "month"
          };
      case DID_REQUEST_INITIAL_DATA:
        return {
            ...state,
            didRequestInitialData: true
          };

      case RECEIVE_RELEVANCE_DATA:
        let relevanceData = state.relevanceData || {};
        //relevanceData[action.payload.group] = action.payload;
        relevanceData.data = action.payload;
        relevanceData.relevanceGroup = 'month';
        return {
          ...state,
          relevanceData: relevanceData
        }
      case RECEIVED_BRAND_AWARENESS_DATA:
        return {
          ...state,
          brandAwarenessData: action.payload
        }
      case RECEIVED_AD_AWARENESS_DATA:
        return {
          ...state,
          adAwarenessData: action.payload
        }
      case 'RECEIVED_SOV_DATA':
        return {
          ...state,
          sovData: action.payload
        }
      case RECEIVED_BRAND_CONSIDERATION_DATA:
        return {
          ...state,
          brandConsiderationData: action.payload
        }
      case SET_RELEVANCE_GROUP:
        return {
          ...state,
          relevanceGroup: action.payload,
        };

      case UPDATE_DATA:
        return {
          ...state,
          simulationParams: action.payload,
        }
      case LOAD_SIMULATION:
        return {
          ...state,
          variableData: action.payload.data,
          simulationParams: action.payload.simulationParams,
          simulationMode: true
        }

      case NEW_SIMULATION:
        return {
            ...state,
            simulationMode: action.payload
        };

      case EXIT_SIMULATION:
        return {
            ...state,
            simulationMode: false,
            simulationParams: {}
        };
      case GET_SAVED_SIMULATIONS:
        let simulations = action.payload;
        if (simulations !== null) {
          Object.keys(simulations).forEach(key => {
            simulations[key].id = key;
          });
        };
        return {
          ...state,
          simulations: simulations
        };
      case TOGGLE_RELEVANCE_CHART:
        return {
          ...state,
          relevanceChartActive: action.payload
        }
      case UPDATE_WASHED_SENTIMENT_DATA:
        return {
          ...state,
          washedSentimentData: action.payload
        }

      case GET_CLIENTS:
        return {
            ...state,
            clients: action.payload
        };

      default:
          return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/dataReducer.js